import styled from 'styled-components';

import Button from '../../components/Button';

const MenuButton = styled(Button)`
  && {
    width: 100%;
  }
`;

const GroupEntryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export { MenuButton, GroupEntryContainer };
